import React, { useState } from 'react';
import StoryBox from './StoryBox/StoryBox';

const renderStoryBox = (story, idx, currentStoryIndex, setCurrentStoryIndex) => (
  <div key={ idx } style={ { margin: '15px 0' } }>
    <StoryBox story={ story } currentStoryIndex={ currentStoryIndex } idx={ idx } setCurrentStoryIndex={ setCurrentStoryIndex } />
  </div>
);

const StoriesList = ({ stories }) => {
  const [currentStoryIndex, setCurrentStoryIndex] = useState(null);

  const handleStoryPress = storyIndex => {
    setCurrentStoryIndex(currentStoryIndex === storyIndex ? null : storyIndex);
  }

  if (!stories) {
    return null;
  }

  return (
    <div style={ { display: 'flex', flexDirection: 'column', alignItems: 'center' } }>
      { stories.map((story, idx) => renderStoryBox(story, idx, currentStoryIndex, handleStoryPress)) }
    </div>
  );
};

export default StoriesList;



// WEBPACK FOOTER //
// ./src/components/ForStudents/Stories/StoriesList/StoriesList.js